export default __webpack_public_path__ + "static/media/1 SCREENING EQUIPMENT.df01a4b7.png";